<template>
  <div class="print-purchase-out-apply">
    <div class="content-wrapper">
      <!-- 标题 -->
      <h2 class="print-title">{{ $t('purchaseApplyDetail.outApplyTitle') }}</h2>

      <!-- 申请单信息 -->
      <div class="info-row">
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applyNo') }}</span>
          <span class="info-value">{{ printPurchaseOutApplyInfo.applyOrderId }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applicant') }}</span>
          <span class="info-value">{{ printPurchaseOutApplyInfo.userName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.contactPhone') }}</span>
          <span class="info-value">{{ printPurchaseOutApplyInfo.endUserTel }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">{{ $t('purchaseApplyDetail.applyTime') }}</span>
          <span class="info-value">{{ printPurchaseOutApplyInfo.createTime }}</span>
        </div>
      </div>

      <!-- 领用明细表格 -->
      <table class="print-table">
        <thead>
          <tr>
            <th class="col-type">{{ $t('purchaseApplyDetail.itemType') }}</th>
            <th class="col-name">{{ $t('purchaseApplyDetail.itemName') }}</th>
            <th class="col-code">{{ $t('purchaseApplyDetail.itemCode') }}</th>
            <th class="col-warehouse">{{ $t('purchaseApplyDetail.warehouse') }}</th>
            <th class="col-spec">{{ $t('purchaseApplyDetail.itemSpec') }}</th>
            <th class="col-supplier">{{ $t('purchaseApplyDetail.supplier') }}</th>
            <th class="col-fixed">{{ $t('purchaseApplyDetail.fixedItem') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.referencePrice') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.billingUnitPrice') }}</th>
            <th class="col-price">{{ $t('purchaseApplyDetail.additionalFee') }}</th>
            <th class="col-stock">{{ $t('purchaseApplyDetail.originalStock') }}</th>
            <th class="col-stock">{{ $t('purchaseApplyDetail.currentStock') }}</th>
            <th class="col-qty">{{ $t('purchaseApplyDetail.applyQuantity') }}</th>
            <th class="col-qty">{{ $t('purchaseApplyDetail.receiveQuantity') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in printPurchaseOutApplyInfo.purchaseApplyDetailVo">
            <tr :key="'detail-' + index">
              <td>{{ item.parentRstName }} > {{ item.rstName }}</td>
              <td>{{ item.resName }}</td>
              <td class="text-center">{{ item.resCode }}</td>
              <td class="text-center">{{ item.shName }}</td>
              <td class="text-center">{{ item.specName ? item.specName : '-' }}</td>
              <td class="text-center">{{ item.supplierName ? item.supplierName : '-' }}</td>
              <td class="text-center">{{ item.isFixedName }}</td>
              <td class="text-center">{{ item.consultPrice ? '￥' + item.consultPrice : '-' }}</td>
              <td class="text-center">{{ parseUnitPrice(item.squarePrice) }}</td>
              <td class="text-center">{{ parseAdditionalFee(item.squarePrice) }}</td>
              <td class="text-center">{{ item.originalStock }}{{ item.unitCodeName }}</td>
              <td class="text-center">{{ item.stock ? item.stock : '0' }}{{ item.unitCodeName }}</td>
              <td class="text-center">{{ item.quantity }}{{ item.unitCodeName }}</td>
              <td class="text-center">{{ item.purchaseQuantity ? item.purchaseQuantity + item.unitCodeName : '-' }}</td>
            </tr>
            <tr :key="'remark-' + index">
              <td class="text-center"><strong>{{ $t('purchaseApplyDetail.applyRemark') }}</strong></td>
              <td colspan="6">{{ item.remark }}</td>
              <td class="text-center"><strong>{{ $t('purchaseApplyDetail.receiveRemark') }}</strong></td>
              <td colspan="6">{{ item.purchaseRemark ? item.purchaseRemark : '-' }}</td>
            </tr>
          </template>
          <tr class="sign-row">
            <td colspan="2" class="text-center sign-cell">{{ $t('purchaseApplyDetail.reviewerSignature') }}</td>
            <td colspan="6"></td>
            <td class="text-center sign-cell" colspan="1">{{ $t('purchaseApplyDetail.time') }}</td>
            <td colspan="5"></td>
          </tr>
          <tr class="sign-row">
            <td colspan="2" class="text-center sign-cell">{{ $t('purchaseApplyDetail.applicantSignature') }}</td>
            <td colspan="6"></td>
            <td class="text-center sign-cell" colspan="1">{{ $t('purchaseApplyDetail.time') }}</td>
            <td colspan="5"></td>
          </tr>
        </tbody>
      </table>

      <!-- 操作按钮 -->
      <div id="print-btn" class="button-wrapper">
        <el-button type="warning" @click="closePage" style="margin-right:20px;">
          {{ $t('purchaseApplyDetail.cancel') }}
        </el-button>
        <el-button type="primary" @click="printPurchaseOutApplyDiv">
          <i class="el-icon-printer"></i> {{ $t('purchaseApplyDetail.print') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { listPurchaseApplys } from '@/api/resource/purchaseApplyManageApi'
import { messages } from './purchaseApplyDetailLang'

export default {
  name: 'PrintPurchaseOutApply',
  i18n: {
    messages
  },
  data() {
    return {
      printPurchaseOutApplyInfo: {
        applyOrderId: '',
        userName: '',
        endUserTel: '',
        createTime: '',
        purchaseApplyDetailVo: []
      },
      printFlag: '0'
    }
  },
  created() {
    this.initPrintPurchaseOutApplyDateInfo()
  },
  methods: {
    // 初始化采购领用申请数据
    initPrintPurchaseOutApplyDateInfo() {
      const applyOrderId = this.$route.query.applyOrderId
      const resOrderType = this.$route.query.resOrderType

      if (!applyOrderId) {
        this.$message.error('缺少申请单号参数')
        return
      }

      const params = {
        page: 1,
        row: 1,
        applyOrderId: applyOrderId,
        resOrderType: resOrderType
      }

      listPurchaseApplys(params).then(res => {
        if (res.purchaseApplys && res.purchaseApplys.length > 0) {
          this.printPurchaseOutApplyInfo = res.purchaseApplys[0]
        } else {
          this.$message.error('未找到领用申请信息')
        }
      }).catch(error => {
        console.error('获取领用申请信息失败:', error)
        this.$message.error('获取领用申请信息失败')
      })
    },

    // 解析计费单价（squarePrice中'/'前面的值）
    parseUnitPrice(squarePrice) {
      if (!squarePrice) return '-'
      const parts = String(squarePrice).split('/')
      return parts[0] || '-'
    },
    // 解析附加/固定费用（squarePrice中'/'后面的值）
    parseAdditionalFee(squarePrice) {
      if (!squarePrice) return '-'
      const parts = String(squarePrice).split('/')
      return parts[1] || '-'
    },

    // 打印
    printPurchaseOutApplyDiv() {
      this.printFlag = '1'
      const printBtn = document.getElementById('print-btn')
      if (printBtn) {
        printBtn.style.display = 'none'
      }
      
      window.print()
      
      // 打印后关闭窗口
      setTimeout(() => {
        window.opener = null
        window.close()
      }, 100)
    },

    // 关闭页面
    closePage() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style scoped>
.print-purchase-out-apply {
  padding: 20px;
  background: #fff;
  font-family: "Microsoft YaHei", "SimSun", sans-serif;
}

.content-wrapper {
  margin: 0 auto;
}

.print-title {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #333;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 14px;
  border: 1px solid #333;
  border-radius: 2px;
  padding: 6px 0;
}

.info-item {
  flex: 1 1 25%;
  min-width: 180px;
  padding: 3px 10px;
  box-sizing: border-box;
}

.info-label {
  font-weight: bold;
  color: #333;
  margin-right: 4px;
}

.info-value {
  color: #555;
}

/* 宽表格打印样式 - 13列 */
.print-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.print-table th,
.print-table td {
  border: 1px solid #333;
  padding: 5px 3px;
  font-size: 11px;
  word-break: break-all;
  line-height: 1.3;
}

.print-table thead th {
  background-color: #e0e0e0;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

/* 列宽定义 */
.print-table .col-type { width: 70px; }
.print-table .col-code { width: 65px; }
.print-table .col-warehouse { width: 55px; }
.print-table .col-spec { width: 55px; }
.print-table .col-supplier { width: 55px; }
.print-table .col-fixed { width: 42px; }
.print-table .col-price { width: 55px; }
.print-table .col-stock { width: 50px; }
.print-table .col-qty { width: 50px; }

.print-table .sign-row {
  height: 45px;
}

.print-table .sign-row td {
  vertical-align: middle;
}

.sign-cell {
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.button-wrapper {
  text-align: right;
  margin-top: 25px;
  padding: 15px 0;
}

/* 打印样式 - 横向打印以容纳13列 */
@media print {
  @page {
    size: A4 landscape;
    margin: 6mm;
  }

  .print-purchase-out-apply {
    padding: 0;
  }

  #print-btn {
    display: none !important;
  }

  .print-title {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .info-row {
    margin-bottom: 8px;
  }

  .print-table th,
  .print-table td {
    font-size: 10px;
    padding: 3px 2px;
  }

  .print-table thead th {
    background-color: #e0e0e0 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>

